import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=1c4b20fc&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=1c4b20fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b20fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4b20fc')) {
      api.createRecord('1c4b20fc', component.options)
    } else {
      api.reload('1c4b20fc', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=1c4b20fc&scoped=true", function () {
      api.rerender('1c4b20fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ForgotPassword.vue"
export default component.exports